/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable no-unused-expressions */
import { getPaymentList } from 'APIs/payment.api'
import { hideOverlay, showModalMessage, showOverlay } from 'Modules/store/actions'
import { call, put, takeLatest } from 'redux-saga/effects'
import { REQUEST, SUCCESS } from 'Stores'
import { formatMessage } from 'Utils/formatMessage'
import { GET_PAYMENT } from './constants'

export function* getPaymentSaga({ payload }) {
  try {
    yield put(showOverlay())
    const data = yield call(getPaymentList, payload)
    yield put({
      type: SUCCESS(GET_PAYMENT),
      payload: {
        getPayment: data.result
      }
    })
    yield put(hideOverlay())
  } catch (error) {
    yield put(hideOverlay())
    yield put(showModalMessage({ message: formatMessage(error) }))
  }
}

export default function* paymentSaga() {
  yield takeLatest(REQUEST(GET_PAYMENT), getPaymentSaga)
}
